export default "/assets/images/problem-solved-01.bcae60553529c1ce.webp";